<template>
  <div class="i-quiz-header">
    <div class="inner">
      <div
        class="logo"
        @click="goToFirstStep"
      >
        JobTest<span>.</span>org
      </div>
      <div class="meta">
        <div
          v-if="!hideCount"
          class="count"
        >
          Question <span>{{ currentQ }}</span> of {{ totalQ }}
        </div>
        <div class="conf">Confidential</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router"

import { GlobalVariables } from "@/helpers/globalVariables"
import { toFinite } from "lodash"

defineProps({
  currentQ: { type: Number, default: 1 },
  totalQ: { type: Number, default: 11 },
  hideCount: { type: Boolean, default: false }
})

// ROUTES
const router = useRouter()

// FUNCTIONS
const goToFirstStep = () => {
  router.push({
    name: GlobalVariables.urls.firstStep.routeName
  })
}
</script>

<style lang="scss" scoped>
.i-quiz-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #ffffffeb;
  backdrop-filter: blur(12px);
  padding: 0 20px;

  @include respond-to($breakpoint-md) {
    padding: 0 40px;
  }

  .inner {
    max-width: 680px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;

    @include respond-to($breakpoint-md) {
      height: 56px;
      padding: 0 16px;
    }
  }

  .logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    font-family: $serif;
    font-size: 16px;
    color: #111827d1;

    span {
      color: $amber-mid;
    }

    @include respond-to($breakpoint-md) {
      font-size: 20px;
    }
  }

  .meta {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 10px;

    @include respond-to($breakpoint-md) {
      gap: 16px;
      font-size: 12px;
    }
  }

  .count {
    color: $ink-40;
    font-weight: 600;

    span {
      color: $ink;
    }
  }

  .conf {
    font-size: 11px;
    font-weight: 600;
    color: #111827b3;
    letter-spacing: 0.02em;
    background: #1118270f;
    padding: 5px 10px;
    border-radius: 6px;
    border: 1px solid #1118271f;
  }
}
</style>
